import { render, staticRenderFns } from "./_firstTime.vue?vue&type=template&id=c2b6d972&scoped=true&lang=pug&"
import script from "./_firstTime.vue?vue&type=script&lang=js&"
export * from "./_firstTime.vue?vue&type=script&lang=js&"
import style0 from "./_firstTime.vue?vue&type=style&index=0&id=c2b6d972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b6d972",
  null
  
)

export default component.exports